import { connect } from "react-redux";
import UberCancelResolutionModal from "./UberCancelResolutionModal";
import { DISPATCH_MAIN_MODAL_HIDE } from "../../actions/modal";
import { resolveUberBatchTask } from "../../actions/uberResolve";

/**
 * Connecte la modal UberCancelResolutionModal au store Redux.
 *
 * mapStateToProps:
 * - Lit state.dispatch.modal pour verifier si la modal doit s'afficher
 * - Passe task et dock depuis modalData si modalType === 'uber_cancel_resolution'
 *
 * mapDispatchToProps:
 * - onHide: dispatch DISPATCH_MAIN_MODAL_HIDE pour fermer la modal
 * - onConfirm: dispatch resolveUberBatchTask pour lancer l'extraction
 */
const mapStateToProps = (state) => {
  const modal = state.dispatch.modal;

  // Verifie si la modal doit s'afficher
  if (!modal || modal.modalType !== "uber_cancel_resolution") {
    return { modal: null };
  }

  // Recupere les erreurs de resolution depuis les deliveries
  const task = modal.task;
  const deliveries = state.dispatch.deliveries;
  let updatedTask = task;

  if (task && deliveries) {
    const foundTask = deliveries.find((t) => t.id === task.id);
    if (foundTask) {
      updatedTask = foundTask;
    }
  }

  return {
    modal: {
      ...modal,
      task: updatedTask,
    },
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onHide: () => dispatch({ type: DISPATCH_MAIN_MODAL_HIDE }),
    onConfirm: (task, dock, deliveryId) => dispatch(resolveUberBatchTask(task, dock, deliveryId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UberCancelResolutionModal);
